export enum SubjectCategory {
    RegularCourses = 1,
    OneOffActions = 2
}